import { Controller } from 'react-hook-form'

import { Text } from '@/src/domains/design-system/components/Text'
import type { SelfAssessmentWizardFormValues } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizard.schema'
import { SelfAssessmentWizardCard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizardCard'
import type { SelfAssessmentQuestion } from '@/src/domains/self-assessments/schemas'

import { SelfAssessmentWizardQuestionActions } from './SelfAssessmentWizardQuestionActions'
import { SelfAssessmentWizardQuestionField } from './SelfAssessmentWizardQuestionField'
import { SelfAssessmentWizardQuestionProgress } from './SelfAssessmentWizardQuestionProgress'

export interface SelfAssessmentWizardQuestionUIProps {
  question: SelfAssessmentQuestion
  questionIndex: number
}

export const SelfAssessmentWizardQuestionUI = ({ question, questionIndex }: SelfAssessmentWizardQuestionUIProps) => {
  return (
    <SelfAssessmentWizardCard heading={question.title} autoFocus>
      <SelfAssessmentWizardQuestionProgress />

      <Text element="p" variant="sm" className="text-petrol-500">
        {question.description}
      </Text>

      <Controller<SelfAssessmentWizardFormValues, `answers.${number}`>
        name={`answers.${questionIndex}`}
        render={({ field, fieldState }) => (
          <SelfAssessmentWizardQuestionField
            question={question}
            value={field.value ?? null}
            error={fieldState.error?.message}
            onBlur={field.onBlur}
            onChange={field.onChange}
          />
        )}
      />

      <SelfAssessmentWizardQuestionActions />
    </SelfAssessmentWizardCard>
  )
}
